import { JustInTimeRoutingConfig } from '@thive/fddm-types';
import { Vector3 } from 'three';

import { Z_INDEX_MAP } from '@/modules/canvas/constants/elements';
import { FDDM_TAG } from '@/modules/floorplanDesign/constants';

export const getHighestJitRoutingPointIndex = (jitRoutingPoints: JustInTimeRoutingConfig[]) =>
  jitRoutingPoints.reduce((highestIndex, item) => {
    const numberMatch = item.name.match(/\d+/);
    const currentNumber = numberMatch ? parseInt(numberMatch[0], 10) : 0;
    return Math.max(highestIndex, currentNumber);
  }, 0);

export const getJitPointElementPosition = (
  relativePositionOnHighwayInPerc: number,
  highwayLength: number,
): Vector3 =>
  new Vector3(
    -highwayLength / 2 + (relativePositionOnHighwayInPerc / 100) * highwayLength,
    0,
    Z_INDEX_MAP[FDDM_TAG.JIT_POINT],
  );
